import React from "react";
import { Icon } from "~assets/frontend/elements/icon/Icon";
import { ResponsiveImage } from "~assets/frontend/elements/responsive-image/ResponsiveImage";
export function Checkbox(props) {
    let image = null;
    if (props.image) {
        if (typeof props.image === "string") {
            image = React.createElement("img", { src: props.image, alt: props.label, className: "mr-12", width: 36, height: 36 });
        }
        else {
            image = React.createElement(ResponsiveImage, Object.assign({}, props.image, { sizes: { extraSmall: { w: 36, h: 36 } }, wrapperClass: "mr-12", caption: "", copyright: "" }));
        }
    }
    return (React.createElement("label", { className: `group/checkbox flex items-center transition-colors ${props.disabled ? "text-black-40" : "cursor-pointer hocus:text-red-100"}` },
        React.createElement("input", { disabled: props.disabled, type: "checkbox", className: ` my-12 mr-12 h-24 w-24 border-none mask-checkbox-unchecked checked:mask-checkbox-checked ${props.disabled ? "bg-black-40 checked:bg-black-40" : "hocus:bg-red-10 bg-black-40 bg-none checked:bg-black-100"}`, checked: props.value, onChange: (event) => {
                props.onChange(event.target.checked);
            } }),
        props.icon && (React.createElement("span", { className: "mr-6" },
            React.createElement(Icon, Object.assign({}, props.icon, { className: `before:transition-colors  ${props.disabled
                    ? "before:bg-black-40"
                    : "before:bg-black-100 group-hover/checkbox:before:bg-red-100 group-focus/checkbox:before:bg-red-100"}` })))),
        image,
        props.label));
}
